module.exports = __webpack_public_path__ + "static/media/Jalorm.7269006a.jpg";